import { useNavigate } from "react-router-dom";
import { SelectOption } from "../../components/dropdown/Dropdown";
import { ActionLinkConfig } from "../../components/helpers/CustomFieldRenderers/SearchListFieldRenderer/SearchListRenderer";
import {
  ACTION_KEY,
  ACTION_SELECTED_ID_KEY,
  APP_ROUTES,
  FILTER_KEY,
  endpoints,
} from "../../config";

export const endpointConfig = {
  editableByRoleIds: endpoints.gateways.search.role,
};
// TODO - UpdateConfig as modules are added
export const linkConfig: ActionLinkConfig = {
  clientID: {
    text: "View client",
    permissionKey: "view",
    location: APP_ROUTES.companies,
  },
  contactsID: {
    text: "View contact",
    permissionKey: "view",
    location: APP_ROUTES.contacts,
  },
  projectsID: {
    text: "View project",
    permissionKey: "view",
    location: APP_ROUTES.projects,
  },

  surveysID: {
    text: "View survey",
    permissionKey: "view",
    location: "/",
  },
};
// TODO - UpdateConfig as modules are added
export const actionLinkTextConfig = {
  clientID: {
    text: "Add new client",
    permissionKey: "create",
    location: APP_ROUTES.sites,
  },
  contactsID: {
    text: "Add new contact",
    permissionKey: "create",
    location: APP_ROUTES.contacts,
  },
  projectsID: {
    text: "Add new project",
    permissionKey: "create",
    location: APP_ROUTES.projects,
  },

  surveysID: {
    text: "Add new survey",
    permissionKey: "create",
    location: "/",
  },
};

export const onLinkClick = <T,>(field: keyof T, option: SelectOption) => {
  const navigate = useNavigate();
  let filterString = "";
  let route = "";

  let action: string | null = null;
  let actionSelectedId: string | null = null;

  // TODO - UpdateConfig - Update cases for modules not built yet
  switch (field) {
    case "projectName":
    case "projectsDescription":
    case "bActive":
      return;
    case "clientID":
      filterString = `Companies__Id EQ (${option.value}) | CompanyTypes__CompanyTypesName CONTAINS (Client)`;
      route = APP_ROUTES.companies;
      break;
    case "contactsID":
      filterString = `Contacts__Id EQ (${option.value})`;
      route = APP_ROUTES.contacts;

      action = "VIEW";
      actionSelectedId = `${option.value}`;
      break;
    case "projectsID":
      filterString = `Projects__Id EQ (${option.value})`;
      route = APP_ROUTES.projects;

      action = "VIEW";
      actionSelectedId = `${option.value}`;
      break;

    case "surveysID":
      filterString = `Surveys__Id EQ (${option.value})`;
      route = ""; // TODO: Add surveys
      break;
  }

  if (filterString) {
    window.localStorage.setItem(FILTER_KEY, filterString);
  }

  if (action) {
    window.localStorage.setItem(ACTION_KEY, action);
  }

  if (actionSelectedId) {
    window.localStorage.setItem(ACTION_SELECTED_ID_KEY, actionSelectedId);
  }

  if (route) {
    navigate(route);
  }
};
export const onActionLinkClick = <T,>(field: keyof T) => {
  const navigate = useNavigate();
  let actionSelectedId: string | null = null;
  let action = "";

  let route = "";

  console.log("onActionLinkClick: ", field);

  // TODO - UpdateConfig - Update cases for modules not built yet
  switch (field) {
    case "projectName":
    case "projectsDescription":
    case "bActive":
      return;
    case "sitesIds":
      route = APP_ROUTES.sites;
      action = "CREATE";
      break;
    case "parentProgrammeIds":
      route = "";
      action = "CREATE";
      break;
    case "employeesInTeamIds":
      route = "";
      action = "CREATE";
      break;
    case "clientCompanyIds":
      route = APP_ROUTES.companies;
      action = "CREATE";
      break;
    case "supplierCompaniesIds":
      route = APP_ROUTES.companies;
      action = "CREATE";
      break;
    case "assetsIds":
      route = "";
      action = "CREATE";
      break;
    case "workflowsIds":
      route = "";
      action = "CREATE";
      break;
    case "documentsIds":
      route = "";
      action = "CREATE";
      break;
    case "contactsID":
      // TODO: Take to bulk uploads panel on the contacts page, pass through the ID
      route = APP_ROUTES.contacts;

      action = "CREATE_BULK";
      // actionSelectedId = `${option.value}`;
      break;

    case "clientId":
      route = APP_ROUTES.companies;
      action = "CREATE";
      break;
  }

  if (action) {
    window.localStorage.setItem(ACTION_KEY, action);
  }

  if (actionSelectedId) {
    window.localStorage.setItem(ACTION_SELECTED_ID_KEY, actionSelectedId);
  }

  // window.open(route, "_blank", "noreferrer");
  if (route) {
    // window.open(route, "_blank", "noreferrer");
    navigate(route);
  }
};
